import { render, staticRenderFns } from "./BrandDataItem.vue?vue&type=template&id=5a9be40a"
import script from "./BrandDataItem.vue?vue&type=script&lang=js"
export * from "./BrandDataItem.vue?vue&type=script&lang=js"
import style0 from "./BrandDataItem.vue?vue&type=style&index=0&id=5a9be40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports